import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '../shared/Button.svelte';
import DatePicker from '../shared/DatePicker.svelte';
import { addWeight } from '../../lib/services/health';
import { showToast } from '../shared/Toast.svelte';
import { getSettings } from '../../lib/stores/settings.svelte.ts';
import { getActiveChild } from '../../lib/stores/children.svelte.ts';
import { lbsToGrams } from '../../lib/utils/units.ts';

var root = $.from_html(`<div class="weight-entry svelte-k6mjzzmq3qv1"><div class="weight-fields svelte-k6mjzzmq3qv1"><div class="field svelte-k6mjzzmq3qv1"><label class="svelte-k6mjzzmq3qv1"> </label> <input type="number" min="0" class="svelte-k6mjzzmq3qv1"/></div> <div class="field svelte-k6mjzzmq3qv1"><label class="svelte-k6mjzzmq3qv1">Date</label> <!></div></div> <!></div>`);

function WeightEntry($$anchor, $$props) {
	$.push($$props, true);

	let weight = $.state('');
	let date = $.state($.proxy(new Date().toISOString().split('T')[0]));
	const settings = $.derived(getSettings);
	const isImperial = $.derived(() => $.get(settings).units === 'imperial');

	async function handleSave() {
		const inputVal = parseFloat($.get(weight));

		if (!inputVal || inputVal <= 0) return;

		const activeChild = getActiveChild();

		if (!activeChild) {
			showToast('No active child selected.', 'error');

			return;
		}

		try {
			const grams = $.get(isImperial) ? lbsToGrams(inputVal) : inputVal;

			await addWeight(activeChild.id, grams, new Date($.get(date)).getTime());
			showToast('Weight saved', 'success');
			$.set(weight, '');
			$$props.onsaved?.();
		} catch(e) {
			showToast('Failed to save weight. Please try again.', 'error');
		}
	}

	var div = root();
	var div_1 = $.child(div);
	var div_2 = $.child(div_1);
	var label = $.child(div_2);
	var text = $.child(label, true);

	$.reset(label);

	var input = $.sibling(label, 2);

	$.remove_input_defaults(input);
	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var node = $.sibling($.child(div_3), 2);

	DatePicker(node, {
		get value() {
			return $.get(date);
		},
		onchange: (v) => $.set(date, v, true)
	});

	$.reset(div_3);
	$.reset(div_1);

	var node_1 = $.sibling(div_1, 2);

	{
		let $0 = $.derived(() => !$.get(weight));

		Button(node_1, {
			variant: 'primary',
			size: 'sm',
			onclick: handleSave,
			get disabled() {
				return $.get($0);
			},

			children: ($$anchor, $$slotProps) => {
				$.next();

				var text_1 = $.text('Save Weight');

				$.append($$anchor, text_1);
			},
			$$slots: { default: true }
		});
	}

	$.reset(div);

	$.template_effect(() => {
		$.set_text(text, $.get(isImperial) ? 'Weight (lbs)' : 'Weight (grams)');
		$.set_attribute(input, 'placeholder', $.get(isImperial) ? 'e.g. 7.7' : 'e.g. 3500');
		$.set_attribute(input, 'step', $.get(isImperial) ? 0.1 : 10);
	});

	$.bind_value(input, () => $.get(weight), ($$value) => $.set(weight, $$value));
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	WeightEntry = $.hmr(WeightEntry);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-k6mjzzmq3qv1');
		WeightEntry[$.HMR].update(module.default);
	});
}

export default WeightEntry;
import "bun-svelte:WeightEntry.svelte-vch98fib8v5p-style.css";